export default {
  categoryList: null,
};
